<template>
    <!-- <div class="container_ flex" id="date-picker_custom"> -->
    <vs-row 
        vs-w="12"
        vs-type="flex"
        id="date-picker_custom"
        >
        <!-- <div class="shortcut flex mr-3"> -->
        <vs-col vs-type="flex" 
                vs-justify="flex-end" 
                vs-align="center" 
                vs-lg="6" 
                vs-sm="6" 
                vs-xs="12"
                class="shortcut"
                >
            <vx-button color="primary" type="border" :active="preset == 'today'" @click="onToday">Hôm nay</vx-button>
            <vx-button class="ml-1 mr-1" color="primary" type="border" :active="preset == 'yesterday'" @click="onYesterday">Hôm qua</vx-button>
            <vx-button color="primary" type="border" :active="preset == 'this_week'" @click="onThisWeek">Tuần này</vx-button>
            <vx-button class="ml-1" color="primary" type="border" :active="preset == 'last_week'" @click="onLastWeek">Tuần trước</vx-button>

            <flat-pickr :config="pickerConfig" v-model="fromDate" placeholder="Từ ngày" />
            <flat-pickr :config="pickerConfig" v-model="toDate" placeholder="Đến ngày" />
            <vs-button class="ml-1" color="primary" @click="dateRangeAction">{{actionBtnText || " Chọn "}}</vs-button>
        </vs-col>
        <!-- </div> -->
    </vs-row>
    <!-- </div> -->
</template>

<style lang="css">
#date-picker_custom{
    justify-content: flex-end;
}
#date-picker_custom .vs-button.small{
    font-size: 1em;
}
#date-picker_custom .vs-button{
    padding: .7rem .2rem !important;
}
#date-picker_custom input.form-control{
    width: 100px;
}
#date-picker_custom .flatpickr-input, .flatpickr-input[type="hidden"] + input{
    width: 100px;
}
</style>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import moment from "moment";

export default{
    props: ["initDate", "actionBtnText", "actionBtn"],
    data(){
        return {
            fromDate: null,
            toDate: null,
            preset: '',
            pickerConfig: {
                altFormat: 'd/m/Y'
            }
        }
    },
    components:{
        flatPickr
    },
    watch: {
        initDate: function(newVal){
            this.fromDate = newVal.from;
            this.toDate = newVal.to;
        }
    },
    methods:{
        onToday(notify = true){
            this.preset = "today";
            this.fromDate = moment().format("YYYY-MM-DD");
            this.toDate = moment().format("YYYY-MM-DD");

            if(notify) this.notifyDateChange();
        },
        onYesterday(){
            this.preset = "yesterday";
            this.fromDate = moment().subtract(1, 'days').format("YYYY-MM-DD");
            this.toDate = moment().subtract(1, 'days').format("YYYY-MM-DD");

            this.notifyDateChange();
        },
        onThisWeek(){
            this.preset = "this_week";
            this.fromDate = moment().startOf('isoWeek').format("YYYY-MM-DD");
            this.toDate = moment().format("YYYY-MM-DD");

            this.notifyDateChange();
        },
        onLastWeek(){
            this.preset = "last_week";
            this.fromDate = moment().subtract(1, 'weeks').startOf('isoWeek').format("YYYY-MM-DD");
            this.toDate = moment().subtract(1, 'weeks').endOf('isoWeek').format("YYYY-MM-DD");

            this.notifyDateChange();
        },
        notifyDateChange(){
            this.$emit('date-change', { fromDate: this.fromDate, toDate: this.toDate });
        },
        dateRangeAction(){
            this.notifyDateChange();
            this.setPreset();
            if(this.actionBtn) this.actionBtn();
        },
        setPreset(from, to){
            if(this.fromDate == moment().format("YYYY-MM-DD") && 
                this.toDate == moment().format("YYYY-MM-DD")){
                    this.preset = "today";
            }else if(this.fromDate == moment().subtract(1, 'days').format("YYYY-MM-DD") && 
                    this.toDate == moment().subtract(1, 'days').format("YYYY-MM-DD")){
                    this.preset = "yesterday";
            }else if(this.fromDate == moment().startOf('isoWeek').format("YYYY-MM-DD") && 
                    this.toDate == moment().format("YYYY-MM-DD")){
                    this.preset = "this_week";
            }else if(this.fromDate == moment().subtract(1, 'weeks').startOf('isoWeek').format("YYYY-MM-DD") && 
                    this.toDate == moment().subtract(1, 'weeks').endOf('isoWeek').format("YYYY-MM-DD")){
                    this.preset = "last_week";
            }else{
                this.preset = "";
                console.log(this.preset);
            }
        }
    },
    mounted(){
        if(this.initDate){

            this.fromDate = this.initDate.from;
            this.toDate = this.initDate.to;
            
            this.setPreset();
        }else{
            this.onToday();
        }
    }
}
</script>

<style lang="scss">
@import "@/assets/scss/main-app/extraComponents/_datetimePicker.scss";

.container{
    flex-direction: row;
}
</style>
